<template>
  <div class="system-builder__dealer-followup--section">

    <div class="system-builder__dealer-followup--container" v-if="alreadySent">
      <p>Sorry, this request has been closed.</p>
      <p>Please submit another request if you would like to receive a quote from another dealer.</p>
      <a class="button__solid--blue" @click="goToViewSystem">Request Another Quote</a>
    </div>

    <div class="system-builder__dealer-followup--container" v-else>
      <h1>Follow-Up Reminder Sent</h1>
      <p>We apologize that you have not been contacted yet by this dealer. A follow-up e-mail, regarding your E-Quote, has been sent to this dealer.</p>
    </div>

  </div>
</template>

<script>
  import store from '../../store'
  import router from '../../router'
  import $ from 'jquery'

  export default {
    components: {},
    name: 'dealerFollowup',
    props: {
      inquiryId: {
        type: String,
        default: ''
      },
      quoteId: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        sharedState: store.state,
        alreadySent: false
      }
    },
    methods: {
      goToViewSystem: function () {
        const currentInquiryId = this.inquiryId
        const currentQuoteId = this.quoteId
        // router.push({name: 'viewSystem', params: {inquiryId: currentInquiryId, quoteId: currentQuoteId}})
        router.push({path: '/view-system/' + currentInquiryId + '/' + currentQuoteId})
      },
      adjustAlreadySentStatus: function (status) {
        this.alreadySent = status
      }
    },
    mounted: function () {
      if (this.inquiryId !== undefined && this.inquiryId !== '' && this.inquiryId.length === 45 && this.quoteId !== 0) {
        // Toggle main nav off
        store.toggleMainNav()

        // Inquiry ID supplied, check against DB
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        var self = this

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          timeout: 7000,
          data: {
            action: 'system-builder-dealer-followup',
            inquiryId: this.inquiryId,
            quoteId: this.quoteId
          },
          cache: false,
          success: function (response) {
            console.log(response === '"Already Sent"')
            if (response === '"Already Sent"') {
              self.adjustAlreadySentStatus(true)
            }
            return false
          }
        })
      } else {
        // If no inquiry ID supplied, do route validation
        store.updateCurrentStateRoute('selectVehicle')
        router.push({name: 'selectVehicle'})
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DealerFollowup.vue?7d89ebf2